module.exports = __webpack_public_path__ + "img/ysd-layout.61fb57eb.png";